/**
 * Campaign Task Media Type
 */
export const CAMPAIGN_TASK_MEDIA_TYPE_POST = 'post';
export const CAMPAIGN_TASK_MEDIA_TYPE_STORY = 'story';
